import { RoutePaths } from 'common-types';

import GuidesIcon from './assets/guides-icon.svg?react';
import HomeIcon from './assets/home-icon.svg?react';
import StyleIcon from './assets/style-icon.svg?react';
import { TPageData } from './types';

export { isNavLinkActive } from './types';

export const pagesData: TPageData[] = [
  {
    title: 'Home',
    href: RoutePaths.HOME,
    Icon: HomeIcon,
  },
  {
    title: 'My plan',
    href: RoutePaths.MY_PLAN,
    Icon: StyleIcon,
  },
  {
    title: 'Outfits',
    href: RoutePaths.OUTFITS,
    Icon: GuidesIcon,
  },
  {
    title: 'Insights',
    href: RoutePaths.INSIGHTS,
  },
];
